class User {
	id = null;
	first_name = '';
	last_name = '';
	email = '';
	contact_number = '';
	password = '';
	active = true;
	user_role_id = 2;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default User;
